// Instellingen als overzicht (oprichter 1 okt: "te gefragmenteerd"): een paar rustige groepen met
// per regel de huidige stand, en drie samengevoegde pagina's (Huishouden, Agenda koppelen en
// exporteren, Locatie en weer). Sleutels in `a.settingsHub.*` (app.nl.ts).
export const appSettingsHubNl = {
    groups: {
        family: {
            title: 'Ons gezin',
            titleHouse: 'Ons huishouden',
            body: 'Wie erbij horen, de taal en wat bij jullie past.',
        },
        agenda: {
            title: 'Agenda',
            body: "Agenda's van buiten erbij halen, delen en exporteren.",
        },
        board: {
            title: 'Bord en tablets',
            body: 'De tablets aan de muur, de kamers, het slot en het weer.',
        },
        modules: {
            title: 'Modules',
            body: 'Welke onderdelen jullie gebruiken, met hun eigen instellingen.',
        },
        account: {
            title: 'Jouw account',
            body: 'Inloggen en beveiliging, meldingen op je telefoon en hoe de app eruitziet.',
        },
        privacy: {
            title: 'Privacy en gegevens',
            body: 'Je gegevens downloaden of wissen, en wie mag meekijken.',
        },
    },
    household: {
        title: 'Huishouden',
        intro: 'Naam, taal en soort huishouden op één plek.',
        nameTitle: 'Naam en tijdzone',
        nameBody: 'De naam staat op het bord en in de e-mails.',
    },
    calendar: {
        title: 'Agenda koppelen en exporteren',
        intro: 'Abonnementslinks, reistijd en de agenda als bestand.',
    },
    locationWeather: {
        title: 'Locatie en weer',
        intro: 'Waar jullie wonen, en wat het bord over het weer laat zien.',
    },
    /** WP3 (docs/ux/compact-plan.md): vijf onderdelen; op de computer lijst links, onderdeel rechts. */
    sections: {
        label: 'Onderdelen van Instellingen',
        household: 'Huishouden',
        family: 'Gezin en tradities',
        house: 'Wat past bij ons huis',
        agenda: 'Agenda',
        modules: 'Modules',
        account: 'Account en privacy',
        accountState: 'Beveiliging, meldingen, thema en je gegevens',
    },
    /** Rechts in een regel met een keuze: opent een blad. */
    change: 'Wijzigen',
    /** Rechts in een regel die alleen uitleg opent (geen keuze). */
    view: 'Bekijken',
    rows: {
        name: 'Naam en tijdzone',
        language: 'Taal',
        type: 'Soort huishouden',
        location: 'Locatie',
        weather: 'Weer op het bord',
        feeds: 'Kalenders van buiten',
        feedsState: 'School, sport en werk in jullie agenda',
        sync: 'Google of Outlook koppelen',
        syncState: 'In twee richtingen, per persoon',
        links: 'Abonnementslinks',
        linksState: 'Jullie agenda in een andere app (één richting)',
        export: 'Exporteren',
        exportState: 'De agenda als bestand (.ics)',
        theme: 'Thema en pictogrammen',
        about: 'Over AMUMIN',
        off: 'Uit',
        nothing: 'Nog niets gekozen',
        ownChoices: 'Eigen keuzes: {names}',
    },
    /** Bord en Gezin als één pagina met tabbladen (compact-plan hoofdstuk 3). */
    hubs: {
        board: {
            title: 'Bord',
            tabs: 'Onderdelen van het bord',
            view: 'Weergave',
            tablets: 'Tablets',
            rooms: 'Kamers',
            frame: 'Fotolijst',
            kidLock: 'Kindslot',
        },
        family: {
            title: 'Gezin',
            tabs: 'Onderdelen van Gezin',
            members: 'Leden',
            links: 'Familie',
            circle: 'Kring',
        },
    },
    tablets: {
        none: 'Nog geen tablet gekoppeld.',
        guide: 'Zo koppel je een iPad',
    },
    members: {
        order: 'Volgorde',
        orderDone: 'Klaar',
    },
    /** Stand bij Modules in het overzicht. */
    modulesCount: '{on} van {total} aan',
    privacyStatement: 'Privacyverklaring',
    privacyStatementBody: 'Wat we bewaren, waarom en hoe lang.',
    /** Trillen bij tikken (1 okt 2026): per gebruiker in de app, per bord in Tablets. */
    haptics: {
        label: 'Trillen bij tikken',
        hint: 'Een korte trilling als je iets indrukt (alleen op een telefoon die dat kan).',
        boardHint: 'Een korte trilling als iemand op het bord iets indrukt. Een iPad trilt niet; daar zie je het indrukken wel.',
    },
};
//# sourceMappingURL=settingsHub.nl.js.map